// extracted by mini-css-extract-plugin
module.exports = {"delete":"styles_delete__3Q4l0","edit":"styles_edit__2V--O","row":"styles_row__1F4V5"};